import { Button, Form, Input, Select, Space } from 'antd'

export type CurriculumFieldType = {
    name: string
    slug: string
    shortCode: string
    guideType: 'DEFAULT_THREE' | 'DEFAULT_TWO'
}

type CurriculumFormProps = {
    title: string
    initialValues?: CurriculumFieldType
    onFinish: (values: CurriculumFieldType) => void
    onCancel: () => void
}

const guideThemeOptions = ['DEFAULT_THREE', 'DEFAULT_TWO']

export const CurriculumForm = ({ title, initialValues, onFinish, onCancel }: CurriculumFormProps) => {
    return (
        <Form labelCol={{ span: 6 }} wrapperCol={{ span: 14 }} layout="horizontal" disabled={false} onFinish={onFinish}>
            <h3>{title}</h3>
            <Form.Item
                label="Name"
                name="name"
                initialValue={initialValues?.name}
                rules={[{ required: true, message: 'Please enter a name' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Slug"
                name="slug"
                initialValue={initialValues?.slug}
                rules={[{ required: true, message: 'Please enter a slug' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Short Code"
                name="shortCode"
                initialValue={initialValues?.shortCode}
                rules={[{ required: true, message: 'Please enter a short code' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item label="Guide Theme" name="guideType">
                <Select defaultValue={initialValues?.guideType}>
                    {guideThemeOptions.map(theme => (
                        <Select.Option key={theme} value={theme}>
                            {theme}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    )
}
